<template>
    <svg width="2601" height="713" viewBox="0 0 2601 713" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 258.769L1402.61 0.503418L2600.5 90.7196V712.503H1299.17H0.5V258.769Z" fill="#86A2AE"
            stroke="#86A2AE" />
    </svg>


</template>